var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{staticClass:"mb-5"},[_c('v-col',{staticClass:"tw-py-0",attrs:{"cols":"12"}},[_c('div',{staticClass:"tw-h-px tw-border"})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }